// WebsiteActions.jsx
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { 
  Edit2, Trash2, Download, ChevronsUpDown, CheckCircle, 
  XCircle, Clock, FileText, Loader2 
} from "lucide-react";
import WebsiteStatusModal from "./WebsiteStatusModal";

const WebsiteActions = ({ row, onEdit, onDelete, onDownload, isAdmin, onSuccess }) => {
  const [statusModalOpen, setStatusModalOpen] = useState(false);

  const buttonVariants = {
    hover: { scale: 1.05, transition: { duration: 0.2 } },
    tap: { scale: 0.95 }
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <motion.button
          whileHover="hover"
          whileTap="tap"
          variants={buttonVariants}
          onClick={() => onEdit(row)}
          className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-100 transition-colors"
        >
          <Edit2 size={16} />
          <span>Edit</span>
        </motion.button>

        <motion.button
          whileHover="hover"
          whileTap="tap"
          variants={buttonVariants}
          onClick={() => onDelete(row)}
          className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 transition-colors"
        >
          <Trash2 size={16} />
          <span>Delete</span>
        </motion.button>

        {isAdmin && (
          <>
            <motion.button
              whileHover="hover"
              whileTap="tap"
              variants={buttonVariants}
              onClick={() => setStatusModalOpen(true)}
              className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-emerald-50 text-emerald-600 hover:bg-emerald-100 transition-colors"
            >
              <ChevronsUpDown size={16} />
              <span>Status</span>
            </motion.button>

            {row.status === "Disapproved" && row.rejectionAttachment && (
              <motion.button
                whileHover="hover"
                whileTap="tap"
                variants={buttonVariants}
                onClick={() => onDownload(row.websiteId)}
                className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-purple-50 text-purple-600 hover:bg-purple-100 transition-colors"
              >
                <Download size={16} />
                <span>Attachment</span>
              </motion.button>
            )}
          </>
        )}
      </div>

      <AnimatePresence>
        {statusModalOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/30 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          >
            <WebsiteStatusModal
              website={row}
              onClose={() => setStatusModalOpen(false)}
              onSuccess={onSuccess}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default WebsiteActions;